import { graphql } from '~publish/graphql'

export const GenerateAnonymousMediaUploadForm = graphql(`
  mutation GenerateAnonymousMediaUploadForm(
    $input: GenerateAnonymousMediaUploadFormInput!
  ) {
    generateAnonymousMediaUploadForm(input: $input) {
      __typename
      ... on GenerateAnonymousMediaUploadFormSuccess {
        assetUrl
        expiresAt
        uploadFields {
          name
          value
        }
        uploadUrl
      }
      ... on InvalidInputError {
        message
      }
      ... on LimitReachedError {
        message
      }
    }
  }
`)

export const AnonymousMediaAccess = graphql(`
  query AnonymousMediaAccess($input: AnonymousMediaAccessInput!) {
    anonymousMediaAccess(input: $input) {
      __typename
      ... on AnonymousMediaAccessSuccess {
        accessUrl
        assetExpiresAt
      }
      ... on InvalidInputError {
        message
      }
      ... on LimitReachedError {
        message
      }
    }
  }
`)
